<tl-button-wrapper #animationRoot>
  <wvr-button-component
    *ngIf="href!== ''"
    [themeVariant]="themeVariant"
    [btnSize]="btnSize"
    [btnTxt]="btnTxt"
    [dispatchAction]="dispatchAction"
    [dispatchActionProps]="dispatchActionProps"
    [href]="href"
    [wvrBtnType]="wvrBtnType">
    <ng-content select="template[button-content]" ngProjectAs="template[button-content]"></ng-content>
  </wvr-button-component>
  <wvr-button-component
    *ngIf="href === ''"
    [themeVariant]="themeVariant"
    [btnSize]="btnSize"
    [btnTxt]="btnTxt"
    [dispatchAction]="dispatchAction"
    [dispatchActionProps]="dispatchActionProps"
    [wvrBtnType]="wvrBtnType">
    <ng-content select="template[button-content]" ngProjectAs="template[button-content]"></ng-content>
  </wvr-button-component>
</tl-button-wrapper>
